import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { HStack } from '~/components/elements/HStack'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { Jump } from '~/components/elements/Jump'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'
import { type Brand } from '~/hooks/useSurveyQuery'

import { brandIdsAtom } from '../atoms'

import styles from './Output.css'
import { StandardAnalysisTable } from './StandardAnalysisTable'

export type OutputProps = {
  brand: Brand
}

export const Output = ({ brand }: OutputProps) => {
  const { t } = useTranslation()
  const setBrandIds = useSetAtom(brandIdsAtom)

  const handleCloseButtonClick = React.useCallback<
    EH<IconButtonProps, 'onClick'>
  >(() => {
    setBrandIds(R.difference([brand.id]))
  }, [brand.id, setBrandIds])

  return (
    <VStack id={`${brand.id}`} spacing={1}>
      <HStack align="center" spacing={0}>
        <Typography variant="heading2">{brand.name}</Typography>

        <IconButton
          buttonStyle="light"
          fillMode="flat"
          icon="trash"
          onClick={handleCloseButtonClick}
        />
      </HStack>

      <StandardAnalysisTable brand={brand} />

      <Jump className={styles.jump} hash="top">
        <Typography variant="link3">{t('back_to_top')}</Typography>
      </Jump>
    </VStack>
  )
}
